import { render, staticRenderFns } from "./voteRecognitionsSingle.vue?vue&type=template&id=02346868&scoped=true"
import script from "./voteRecognitionsSingle.vue?vue&type=script&lang=js"
export * from "./voteRecognitionsSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02346868",
  null
  
)

export default component.exports